import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { GetDemoComponent } from '@pyg-shared/get-demo/get-demo.component';

@Component({
  selector: 'app-case-studies',
  templateUrl: './case-studies.component.html',
  styleUrls: ['./case-studies.component.scss'],
  imports: [TranslatePipe, GetDemoComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaseStudiesComponent {
  public readonly featuredStudies = [
    { key: 'yettel', logo: 'assets/img/CaseStudies/yettel.svg', color: '#00A651' },
    { key: 'flying_tiger', logo: 'assets/img/CaseStudies/flying-tiger.svg', color: '#E4002B' },
    { key: 'o2', logo: 'assets/img/CaseStudies/o2.svg', color: '#0050AA' },
  ];

  public readonly additionalStudies = [
    { key: 'tesco' },
    { key: 'telenor' },
    { key: 'humanic' },
    { key: 'prima_hr' },
  ];
}
